import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';

function getStyle() {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: 10,
      paddingRight: 10,
    },
    label: {
      color: '#787878',
      fontSize: 13,
    },
  });
}

const TimeChartLabels = props => {
  const styles = getStyle();
  const labels = props.labels || [];

  return (
    <View style={styles.container}>
      {labels.map((label, index) => (
        <Text key={index} style={styles.label}>
          {label}
        </Text>
      ))}
    </View>
  );
};

TimeChartLabels.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
};

export default TimeChartLabels;
